import { QueryKey } from '@portal/constants';
import { useInfiniteQuery } from '@tanstack/react-query';
import { findImprIdpUsers } from '../../../../api/portalServices';
import { useSession } from '../../../../common/authorization/context/Session';

const PAGE_SIZE = 100;

export const useIdpUsers = () => {
  const tenantId = useSession().tenantId;

  return useInfiniteQuery({
    queryKey: [QueryKey.FIND_IDP_USERS],
    queryFn: async ({ pageParam }) => {
      if (pageParam === undefined) {
        return { usersTotal: 0, users: [], pageInfo: { count: 0, startIndex: 0 } };
      }
      const payload = { pageInfo: { count: PAGE_SIZE, startIndex: pageParam } };
      return findImprIdpUsers(payload, tenantId || '');
    },
    initialPageParam: 1, //startIndex
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const received = lastPage.users.length;
      if (received === 0) {
        return undefined;
      }

      const nextStartIndex = (lastPageParam as number) + received;
      if (typeof lastPage.usersTotal === 'number' && nextStartIndex > lastPage.usersTotal) {
        return undefined;
      }
      return nextStartIndex;
    },
    select: ({ pages }) => pages.flatMap(page => page.users),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
};
